export const AUTHENTICATOR_CODE_LENGTH = 6

const COMPLETE_CODE = new RegExp(`^\\d{${AUTHENTICATOR_CODE_LENGTH}}$`)

/** All digits, no gaps. */
export function isCompleteAuthenticatorCode(code: string) {
  return COMPLETE_CODE.test(code)
}
